<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Your plan details</template>

    <Sheet.Body>
      <PlanDetailsBody :prices="prices" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import type { BillingPrice } from '@/shared/graphql/legacy/generated'
import PlanDetailsBody from './PlanDetailsBody.vue'

defineProps<{
  prices: BillingPrice[]
}>()

const { close } = useSheet()
</script>
